import { render, staticRenderFns } from "./ElectricityCardDetailTwo.vue?vue&type=template&id=00bec3f0&"
import script from "./ElectricityCardDetailTwo.vue?vue&type=script&lang=js&"
export * from "./ElectricityCardDetailTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports